/**
 * Created by intellicar-rinas on 4/1/18.
 */
import React, {Component} from 'react';
import './ScooterView.css';
import moment from 'moment';
import {dateFormat} from '../../../../constants/constants';
import frame1 from './assets/frame3.png';
import Graph from './graph/graph';

let images = {
    helmet: require('./assets/helmet.png'),
    skull: require('./assets/skull.png'),
    compassarc: require('./assets/compassarc.png'),
    compassneedle: require('./assets/compassneedle2.png'),
    gforce: require('./assets/gforce.png'),
    battery: require('./assets/battery.png'),
    hornon: require('./assets/hornon2.png'),
    hornoff: require('./assets/hornoff.png'),
    indicatoron: require('./assets/indicatoron.png'),
    indicatoroff: require('./assets/indicatoroff.png'),
    fuel: require('./assets/fuel.png'),
    lightbeam: require('./assets/lightbeam.png'),
}

class ScooterView extends Component {

    state = {
        stats:{
            gforce: {},
        },
        voltagehist: [],
        amphist: []
    };

    constructor(){
        super();

        this.updateView =()=> {
            // this.setState({stats:this.props.vehicle().stats}, this.forceUpdate);
            setTimeout(()=>{
                let incomingV = this.props.vehicle().stats
                let stats = {...this.state.stats,...incomingV}
                if('accX' in incomingV && 'accY' in incomingV && 'accZ' in incomingV) {
                    // let left = incomingV.accX * 22 + 44;
                    // let top = incomingV.accY * 22 + 44;
                    let left = Math.max(-1, Math.min(incomingV.accX,1)) * 44 + 44;
                    let top = Math.max(-1, Math.min(incomingV.accY,1)) * 44 + 44;
                    let radius = incomingV.accZ * 2.5 + 10;
                    stats.gforce = {left,top,radius}
                }
                if('batteryA' in incomingV) {
                    stats.batteryIn = incomingV.tvsBatteryA < 0;
                    stats.batteryOut = incomingV.tvsBatteryA > 0;
                }
                if('ignitionstatus' in incomingV) {
                    // console.log('%cign status' + incomingV.ignitionstatus, 'color:red;')
                    if(incomingV.ignitionstatus == 0) stats.rpm = 0
                    if(incomingV.ignitionstatus == 1) stats.tvsHeadlight = 1
                }
                let {voltagehist, amphist} = this.state;
                if(voltagehist.length > 7 && incomingV.batteryV) voltagehist = voltagehist.slice(1);
                if(amphist.length > 7 && incomingV.tvsBatteryA) amphist = amphist.slice(1);
                voltagehist = voltagehist.concat({time:incomingV.uts,value:incomingV.batteryV});
                amphist = amphist.concat({time:incomingV.uts,value:incomingV.tvsBatteryA});
                console.log(stats)
                this.setState({stats,amphist,amphist}, this.forceUpdate);
                // console.log(this.props.vehicle());
            }, 100);

        };
    }

    /*
    *   Throttle
    * */

    getThrottlePercent = () => {
        let throttle = this.state.stats.tvsThrottle || 0
        return throttle + '%';
    }

    /*
    *   Fuel
    * */

    getFuelInPercentage =()=> {
        let fuel = this.state.stats.tvsFuel || 0;
        return fuel;
    };

    getFuelVal =()=> {
        let perc = this.getFuelInPercentage();
        let max = 5;
        let liters = perc * max / 100
        return liters == 0 ? 0 : liters.toFixed(1);
    };

    getFuelDashOffset =()=> {
        return 254 - (this.getFuelInPercentage() / 100 * 127);
    };

    /*
    *   Oil Temp
    * */

    getOilTempVal =()=> {
        return this.state.stats.oiltemp || 0;
    };

    getOilTempInPercentage =()=> {
        return this.getOilTempVal() / 150 * 100
    };

    /*
    *   RPM
    * */

    getRPMVal =()=> {
        return this.state.stats.tvsRpm || 0;
    };

    getRPMInPercentage =()=> {
        return this.getRPMVal() / 12000 * 100
    };

    /*
    *   FINN
    * */
    getFinnTempPercentage = () => {
        let maxVal = 100;
        let finn = this.state.stats.finn || 0;
        return finn / maxVal * 100;
    }

    /*
    *   DIFF
    * */
    getDiffPressurePercentage = () => {
        let maxVal = 200;
        let diff = this.state.stats.diff || 0;
        return diff / maxVal * 100;
    }

    /*
    *   Speed
    * */

    getSpeed =()=> {
        return this.state.stats.tvsSpeed || 0;
    };

    getCompassRotation = () => {
        let deg = this.state.stats.direction || 0
        return 'rotate(' + deg + 'deg)'
    }

    /*
    *   G Force
    * */

    getGForceComb = () => {
        let left = this.state.stats.gforce.left || 44;
        let top = this.state.stats.gforce.top || 44;
        let radius = this.state.stats.gforce.radius || 10;

        left = Math.max(18, Math.min(70, left)) - radius;
        top = Math.max(18, Math.min(70, top)) - radius;

        let width = radius * 2, height = radius * 2;
        let borderRadius = radius;
        return {left,top,width,height,borderRadius}
    }

    /*
    *   Battery
    * */

    getBatteryV = () => {
        let v = this.state.stats.batteryV || 0;
        return v == 0 ? 0 : (v / 1000).toFixed(1);
    }

    getBatteryA = () => {
        let a = this.state.stats.tvsBatteryA || 0
        return a == 0 ? 0 : a.toFixed(1);
    }

    setGPointer = (top, left, radius) => {
        this.setState({
            stats: {
                ...this.state.stats,
                gforce: {top,left,radius}
            }
        })
    }
    
    renderOdo(odo) {
        odo = odo || 0;
        let strodo = odo.toString().padStart(6, '0')
        return <div className="sv-odo-m">
            {[].map.call(strodo, (s, i) => <div key={i}>{s}</div>)}
        </div>
    }

    render() {
        return (
            <div className="ScooterView">
                <div className="sv-indtop">
                    <div className="sv-indtop-lft">
                        <img src={parseInt(this.state.stats.helmet) ? images.helmet : images.skull} />
                    </div>
                    <div className="sv-indtop-rgt">
                        <div className="sv-indtc">
                            <img className="sv-ind-stk" src={images.compassarc} />
                            <img className="sv-ind-flt" src={images.compassneedle} style={{transform:this.getCompassRotation()}} />
                        </div>
                    </div>
                </div>
                <div className="sv-dial">
                    <div className="svdm-fuel-ico">
                        <img src={images.fuel} />
                    </div>
                    <div className={'svdm-ind-c rgt' + (parseInt(this.state.stats.indicatorRight) == 1 ? ' blink': '')}>
                        <img src={images.indicatoroff} />
                        {parseInt(this.state.stats.indicatorRight) == 1 && <img className="indcflt" src={images.indicatoron} />}
                    </div>
                    <div className={'svdm-ind-c lft' + (parseInt(this.state.stats.indicatorLeft) == 1 ? ' blink': '')}>
                        <img src={images.indicatoroff} />
                        {parseInt(this.state.stats.indicatorLeft) == 1 && <img className="indcflt" src={images.indicatoron} />}
                    </div>
                    <div className="svdm-horn">
                        <img src={parseInt(this.state.stats.tvsHorn) ? images.hornon : images.hornoff} />
                    </div>
                    <div className="svd-main">
                        <div className={"svdm-brake-pd lft"  + (parseInt(this.state.stats.tvsBrakeR) ? ' actv' : '')}>
                            <div className="svdm-brake-pdd"></div>
                        </div>
                        <div className={"svdm-brake-pd rgt" + (parseInt(this.state.stats.tvsBrakeF) ? ' actv' : '')}>
                            <div className="svdm-brake-pdd"></div>
                        </div>
                        <div className="svdm-throttle-pd">
                            <div className="svdm-throttle-pdd" style={{width:this.getThrottlePercent()}}>
                                <div className="svdm-throttle-pdx"></div>
                            </div>
                        </div>
                        <div className="svdm-lgt-beam">
                            <img src={this.state.stats.tvsHeadlight ? images.lightbeam : null} />
                        </div>
                        <div className="svdm-battery">
                            <div className="svdmb-bg"></div>
                            <div className="svdmb-val">{this.getFuelVal()}<span>LTR</span></div>
                            <svg>
                                <circle className="svdmb-bg-circle"></circle>
                                <circle className="svdmb-main-circle"  style={{strokeDashoffset:this.getFuelDashOffset()}}></circle>
                                <circle className="svdmb-overlay-circle"></circle>
                                <circle className="svdmb-outline-circle"></circle>
                            </svg>
                        </div>
                        <div className="svdm-battery -dummy">
                            <svg>
                                <circle className="svdmb-main-circle"  style={{strokeDashoffset:this.getFuelDashOffset()}}></circle>
                            </svg>
                        </div>
                        <div className="svdm-vertical-progress">
                            <div className="svdmvp-bar">
                                <div className="svdmvpb-value" style={{height:this.getOilTempInPercentage()+'%'}}>
                                    <div className="svdmvpbv-grad"></div>
                                </div>
                                <div className="svdmvpb-overlay"></div>
                                <div className="svdmvpb-value -blurred" style={{height:this.getOilTempInPercentage()+'%'}}>
                                    <div className="svdmvpbv-grad"></div>
                                </div>
                            </div>
                            <div className="svdmvp-value">{this.getOilTempVal()}<span>°C</span></div>
                            <div className="svdmvp-name">OIL TEMP</div>
                        </div>
                        <div className="svdm-vertical-progress -right">
                            <div className="svdmvp-bar">
                                <div className="svdmvpb-value" style={{height:this.getRPMInPercentage()+'%'}}>
                                    <div className="svdmvpbv-grad"></div>
                                </div>
                                <div className="svdmvpb-overlay"></div>
                                <div className="svdmvpb-value -blurred" style={{height:this.getRPMInPercentage()+'%'}}>
                                    <div className="svdmvpbv-grad"></div>
                                </div>
                            </div>
                            <div className="svdmvp-value">{this.getRPMVal()}</div>
                            <div className="svdmvp-name">RPM</div>
                        </div>
                        <div className="svdm-speed">
                            <div className="svdms-val">{this.getSpeed()}</div>
                            <div className="svdms-unit">KMPH</div>
                        </div>
                    </div>
                    <div className="svd-bg">
                        <img alt="" src={frame1}/>
                    </div>
                </div>
                <div className="sv-odogf">
                    <div className="sv-odogfl">
                        <img src={images.gforce} />
                        <div className="sv-odogfl-b">
                            <div className="sv-odogfl-bc" style={this.getGForceComb()}></div>
                        </div>
                    </div>
                    <div className="sv-odogfr">
                        <div>
                            {this.renderOdo(this.state.stats.frontodo)}
                        </div>
                    </div>
                </div>
                <div className="sv-div"><div></div></div>
                <div className="sv-df-blk">
                    <div className="sv-df-blk-c">
                        <div>
                            <div className="sv-df-blk-hd">
                                <div className="sv-df-blk-hdl">DIFF PRESSURE</div>
                                <div className="sv-df-blk-hdr">{this.state.stats.diff}<span>psi</span></div>
                            </div>
                            <div className="sv-df-blk-pb">
                                <div className="sv-df-blk-pbr">
                                    <div className="svdf-bar">
                                        <div className="svdfb-value" style={{width:this.getDiffPressurePercentage()+'%'}}>
                                            <div className="svdfb-grad"></div>
                                        </div>
                                        <div className="svdfb-overlay"></div>
                                        <div className="svdfb-value -blurred" style={{width:this.getDiffPressurePercentage()+'%'}}>
                                            <div className="svdfb-grad"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sv-df-blk-c">
                        <div>
                            <div className="sv-df-blk-hd">
                                <div className="sv-df-blk-hdl">FINN TEMP</div>
                                <div className="sv-df-blk-hdr">{this.state.stats.finn}<span>&#176;C</span></div>
                            </div>
                            <div className="sv-df-blk-pb">
                                <div className="sv-df-blk-pbr">
                                    <div className="svdf-bar">
                                        <div className="svdfb-value" style={{width:this.getFinnTempPercentage()+'%'}}>
                                            <div className="svdfb-grad"></div>
                                        </div>
                                        <div className="svdfb-overlay"></div>
                                        <div className="svdfb-value -blurred" style={{width:this.getFinnTempPercentage()+'%'}}>
                                            <div className="svdfb-grad"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sv-block2">
                    <div className="svb2-battery">
                        <div className="svb2-battery-in">
                            <div className="svb2-hd">BATTERY</div>
                            <div className="svb2-fltr lft">
                                <img src={this.state.stats.batteryIn ? images.indicatoron : images.indicatoroff} />
                            </div>
                            <div className="svb2-img-out">
                                <img src={images.battery} />
                                <div className="svb2-lbl lft">{this.getBatteryV()}<span>V</span></div>
                                <div className="svb2-lbl rgt">{this.getBatteryA()}<span>A</span></div>
                            </div>
                            <div className="svb2-fltr rgt">
                                <img src={this.state.stats.batteryOut ? images.indicatoron :images.indicatoroff} />
                            </div>
                        </div>
                    </div>
                    <div className="svb2-graph">
                        <div className="svb2-graph-inner">
                            <Graph voltagehist={this.state.voltagehist} amphist={this.state.amphist} />
                        </div>
                    </div>
                </div>
                <div className="sv-mrr-blk">
                    <div className="sv-mrr-bx lft">
                        <div className="sv-mrr-bxh">MAP</div>
                        <div className="sv-mrr-bxv">{this.state.stats.map || 0}<span>PSI</span></div>
                    </div>
                    <div className="sv-mrr-ct">
                        <div className="sv-mrr-cth">REAR WHEEL</div>
                        {this.renderOdo(this.state.stats.rearodo)}
                    </div>
                    <div className="sv-mrr-bx rgt">
                        <div className="sv-mrr-bxh">REAR WHEEL</div>
                        <div className="sv-mrr-bxv">{this.state.stats.rspeed || 0}<span>KMPH</span></div>
                    </div>
                </div>
            </div>
        )
    }

}

export default ScooterView;